import { Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TouaregControlLayoutMessage } from '../../layout/touareg-control-state-layout.component'
import { Samv2Module } from '@aubert-et-duval/samv2';

@Component({
  selector: 'app-touareg-control-message-dialog',
  templateUrl: './touareg-control-message-dialog.component.html',
  styleUrls: ['./touareg-control-message-dialog.component.scss'],
  imports: [Samv2Module],
})
export class TouaregControlMessageDialogComponent implements OnInit, OnDestroy {
  public classes!: string

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { message: TouaregControlLayoutMessage },
    public dialogRef: MatDialogRef<TouaregControlMessageDialogComponent>
  ) {}

  ngOnInit(): void {
    //this._initState()
    if (this.data?.message) {
      this.classes = `message-${
        this.data.message.type ? this.data.message.type : 'info'
      }`
    }
  }

  public close() {
    this.dialogRef.close()
  }

  ngOnDestroy(): void {}
}
